import { type FC, useState } from "react"

import InputLabel from "../InputLabel"
import Dropzone from "./Dropzone"
import Preview from "./Preview"
import Uploading from "./Uploading"

export const recommendedSizes = {
	thumbnail: "1920 x 1080 (16:9)",
	logo: "any x 128",
	ogImage: "1200 x 630 (social media)",
	favicon: "128 x 128 (square)",
} satisfies Record<string, string>

type Props = {
	label?: string
	disableSvg?: boolean
	filePath: string | null
	onUpload(file: File): Promise<void> | void
	onDelete(): Promise<void> | void
	recommendedSize?: keyof typeof recommendedSizes
}
const ImageUploader: FC<Props> = ({ label, filePath, onUpload, onDelete, recommendedSize, disableSvg = false }) => {
	const [uploadingFile, setUploadingFile] = useState<File>()

	const content =
		filePath !== null ? (
			<Preview imageFilePath={filePath} onDelete={onDelete} />
		) : uploadingFile ? (
			<Uploading file={{ name: uploadingFile.name, size: uploadingFile.size }} />
		) : (
			<Dropzone
				disableSvg={disableSvg}
				recommendedSize={recommendedSize}
				onImageDrop={async (file: File) => {
					setUploadingFile(file)
					try {
						await onUpload(file)
					} finally {
						setUploadingFile(undefined)
					}
				}}
			/>
		)

	if (label === undefined) return content

	return (
		<div>
			<InputLabel>{label}</InputLabel>
			{content}
		</div>
	)
}

export default ImageUploader
